import { Fragment, useState } from 'react';
import {
  Alert,Button, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog, DialogActions, Typography, DialogContent,
  TextField, FormControl, OutlinedInput, FormHelperText, InputLabel, FilledInput, Popover, Snackbar, IconButton
} from '@mui/material';

import { selectCurrentUser } from "../../../redux/reducers/authSlice"
//import { DataGrid, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton, GridToolbarQuickFilter } from "@mui/x-data-grid";
import {
  DataGridPro, GridToolbarQuickFilter , gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
  GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';
import { centsToPesos } from "../../../lib/utils/index.js"
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Delete, Add, Edit, PushPin } from '@mui/icons-material';
import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import Notification from "../../../components/Notification";
import { removeEmpty } from "../../../lib/utils/index.js";
import { useEffect } from 'react';
import theme from '../../../theme';
import { getIndices, addIndice, editIndice, deleteIndice} from "./indicesSlice.js";
import { useSelector, useDispatch} from 'react-redux';


export default function IndicesCat() {
  const moneyFormat = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v).toFixed(2)).replace('ARS', '');
  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  };
  function getFormatoFecha(fecha) {
    fecha = fecha.toString()
    let y = fecha.substring(0, 4)
    let m = fecha.substring(4, 6)
    let d = fecha.substring(6, 8)
    return d + '/' + m + '/' + y
  };
  function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(",");
    date = date[0].split("/");

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];

    var fullDate = y + m + d;
    return fullDate;
  };
  const fechaSortComparator = (v1, v2, param1, param2) => {
    function getFechaNumero(date) {
      date = date.split('/')
      let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
      let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
      let y = date[2];
      var fullDate = y + m + d;
      return parseInt(fullDate);
    }
    let fecha1 = getFechaNumero(param1.value)
    let fecha2 = getFechaNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
      fecha1,
      fecha2,
    );
    if (ComparatorResult !== 0) {
      return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
  };
  const importeSortComparator = (v1, v2, param1, param2) => {
    function getImporteNumero(importe) {
      importe = importe.replace('$', '').replace(',', '').replace('.', '')
      return parseInt(importe);
    }
    let number1 = getImporteNumero(param1.value)
    let number2 = getImporteNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
      number1,
      number2,
    );
    if (ComparatorResult !== 0) {
      return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
  };
  const currentUser = useSelector(selectCurrentUser);

  const dispatch = useDispatch();
  const { fetching,  message, error } = useSelector(state => state.indices);
  const indices = useSelector(state => state.indices.data);
  useEffect(() => { dispatch(getIndices()) }, []);

  const Header = (props) => {
    return (<Fragment>
      <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>Histórico De Índices</Typography>
      {fetching > 0 && <p>Cargando</p>}
    </Fragment>);
  };
  const Notification = (props) => {
    const [showNotification, setShowNotification] = useState(true);
    const onClose = () => setShowNotification(false);
    return (<>{error || message ? 
    <Snackbar fullWidth anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={showNotification} autoHideDuration={6000} onClose={onClose} >
      <Alert sx={{ bgcolor: 'background.paper', fontWeight: 'bold' }} severity={error ? 'error' : 'success'} variant={'outlined'} fullWidth>
       <Typography color={'primary'} fontWeight={'bold'} children={error ? error : message} />
      </Alert>
    </Snackbar>: null }</>)
  };
  const IndicesTable = (props) => {
    const [showNuevoItemForm, setShowNuevoItemForm] = useState(false);
    const [estamosEditando, setEstamosEditando] = useState(false);
    const openForm = () => setShowNuevoItemForm(true);
    const closeForm = () => setShowNuevoItemForm(false);
    let rows = (indices)?.map(i => ({
      ...i,
      cac: i.cac / 100.0,
      cvs: i.cvs / 100.0,
      blu: i.blu / 100.0,
      mep: i.mep / 100.0,
      tur: i.tur / 100.0,
      ofi: i.ofi / 100.0,
    }));

    function handleEdit(indice) {
      let indiceSeleccionado = (indices)?.find(i => i.indiceId === indice.indiceId);
      if (indiceSeleccionado) {
        setEstamosEditando({ ...indiceSeleccionado, fecha: dayjs(new Date(parseInt(indiceSeleccionado.fecha))) });
        setShowNuevoItemForm(true);
      }
    };

    function handleDeleteSubmit(id) {
      dispatch(deleteIndice([parseInt(id)])).unwrap()
        .then(console.log)
        .catch(console.log)
    };

    const NuevoIndiceForm = (props) => {
      let moneyKeys = ['oficial', 'turista', 'blue', 'mep', 'cac', 'cvs'];
      const [errores, setErrores] = useState([]);
      let indiceAux = { ...props.indice };
      moneyKeys.forEach(k => indiceAux[k] != null && (indiceAux[k] /= 100)); //A: convert to pesos
      const [indice, setIndice] = useState({ ...indiceAux });
      let estamosEditando = props.indice.indiceId;
      function createNewIndex() {
        //check if all values in obj are empty strings
        setErrores([]);
        let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores

        function isEmpty(obj) {
          for (var key in obj) {
            if (key !== 'fecha' && obj[key] !== "") {
              return false;
            }
          }
          return true;
        }

        if (isEmpty(indice)) {
          setErrores(['Debe completar al menos un campo']);
          huboError = true;
        }

        //validar que no exista una fecha para el mismo mes, dia y año
        const fecha = dayjs(indice.fecha).format('YYYY-MM-DD');
        const indiceEncontrado = (indices).find(i => dayjs(parseInt(i.fecha)).format('YYYY-MM-DD') === fecha);
        if (!estamosEditando && indiceEncontrado) {
          setErrores(errors => [...errors, 'Ya existe un índice para la fecha seleccionada']);
          huboError = true;
        }

        //validar que la fecha no sea mayor que hoy
        if (indice.fecha.isAfter(dayjs(Date.now()))) {
          setErrores(errors => [...errors, 'La fecha no puede ser mayor a hoy']);
          huboError = true;
        }
        if (huboError) return;

        indice.fecha = indice.fecha.valueOf(); //valueOf returns milliseconds
        Object.keys(indice).forEach(k => indice[k] = isNaN(indice[k]) ? null : indice[k]); //A: clean nan values and convert strings or floats to ints
        moneyKeys.forEach(k => indice[k] = indice[k] ? parseInt((indice[k] * 100).toFixed(0)) : indice[k])
        if (estamosEditando) {
          removeEmpty(indice);
          dispatch(editIndice(indice)).unwrap()
            .then(console.log)
            .catch(console.log);
        } else {
          removeEmpty(indice);
          dispatch(addIndice(indice)).unwrap()
            .then(console.log)
            .catch(console.log);
        }

      }

      return (
        <Fragment>
          <Dialog onClose={closeForm} open={showNuevoItemForm}>
            <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>{estamosEditando ? (`Edición de Índice ${getFormatoFecha(getFecha(parseInt(indice.fecha.valueOf())))}:`) : 'Nuevo Índice:'}</DialogTitle>
            <DialogContent dividers>
              <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <div>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.oficial}
                      onChange={e => setIndice({ ...indice, oficial: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">Oficialll</FormHelperText>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.turista}
                      onChange={e => setIndice({ ...indice, turista: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">Turista</FormHelperText>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.blue}
                      onChange={e => setIndice({ ...indice, blue: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">BLUE</FormHelperText>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.mep}
                      onChange={e => setIndice({ ...indice, mep: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">MEP</FormHelperText>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.cac}
                      onChange={e => setIndice({ ...indice, cac: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">CAC</FormHelperText>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <OutlinedInput
                      value={indice.cvs}
                      onChange={e => setIndice({ ...indice, cvs: parseFloat(e.target.value) })}
                      id="outlined-adornment-weight"
                      type="number"
                    />
                    <FormHelperText id="outlined-weight-helper-text">CVS</FormHelperText>
                  </FormControl>


                  <FormControl sx={{ m: 1 }} variant="outlined">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Fecha"
                        inputFormat="DD/MM/YYYY"
                        value={indice.fecha}
                        onChange={(v) => setIndice({ ...indice, fecha: v })}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </div>

                <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ color: 'error.main' }}>
                    {errores.length > 0 && errores.map((error, i) => <p style={{ marginLeft: '8px' }} key={'errIndices' + i}>- {error}</p>)}
                  </Grid>

                  <Grid item xs={12}>
                  </Grid>
                </Grid>

              </Box>

            </DialogContent>

            <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
              <Button variant="outlined" onClick={closeForm} sx={{ fontWeight: "bold" }}>{"Cancelar"}</Button>
              <Button variant="contained" onClick={createNewIndex} sx={{ marginRight: '5px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      )
    };
    const GridAction = (props) => {
      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
      };

      const handlePopoverClose = () => {
        setAnchorEl(null)
      };
      const { label, key, Icon } = props;
      const open = Boolean(anchorEl);
      return (
        <Fragment key={key + label}>
          <Icon aria-owns={open ? label : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}> </Icon>
          <Popover
            id={label}
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{label}</Typography>
          </Popover>
        </Fragment>
      )
    };
    const columns = [
      //{ field: 'pin', headerName: '', width: .3, renderCell: v => <IconButton className="mb-3" variant="contained" color='secondary' onClick={()=>console.log('click')}><PushPin /></IconButton>},
      { field: 'indiceId', headerName: 'ID', width: 100, renderCell: v => v.row.indiceId },
      { field: 'fecha', headerName: 'Fecha', width: 140, valueGetter: v => getFormatoFecha(getFecha(v.row.fecha)), sortComparator: fechaSortComparator },
      { field: 'cac', headerName: 'CAC', width: 140, valueGetter: v => v.row.cac ? ('$' + moneyFormat(parseFloat(v.row.cac))) : '-', sortComparator: importeSortComparator },
      { field: 'cvs', headerName: 'CVS', width: 140, valueGetter: v => v.row.cvs ? ('$' + moneyFormat(parseFloat(v.row.cvs))) : '-', sortComparator: importeSortComparator },
      { field: 'blue', headerName: 'BLUE', width: 140, valueGetter: v => v.row.blu ? ('$' + moneyFormat(parseFloat(v.row.blu))) : '-', sortComparator: importeSortComparator },
      { field: 'mep', headerName: 'MEP', width: 140, valueGetter: v => v.row.mep ? ('$' + moneyFormat(parseFloat(v.row.mep))) : '-', sortComparator: importeSortComparator },
      { field: 'turista', headerName: 'Turista', width: 140, valueGetter: v => v.row.tur ? ('$' + moneyFormat(parseFloat(v.row.tur))) : '-', sortComparator: importeSortComparator },
      { field: 'oficial', headerName: 'Oficial', width: 140, valueGetter: v => v.row.ofi ? ('$' + moneyFormat(parseFloat(v.row.ofi))) : '-', sortComparator: importeSortComparator },
      {
        field: 'actions', headerName: 'Acciones', width: 140, type: 'actions', renderCell: v =>
          <>
            <GridActionsCellItem key={v.row.indiceId + '-editarGridAction'} disabled={currentUser?.permisos?.includes('writeCACs') ? false : true} color={'info'} onClick={() => handleEdit(v.row)} icon={<GridAction label={'Editar'} key={v.row.pagoId} Icon={Edit} />} />
            <GridActionsCellItem key={v.row.indiceId + '-borrarGridAction'} disabled={currentUser?.permisos?.includes('writeCACs') ? false : true} color={'danger'} onClick={() => handleDeleteSubmit(v.row.indiceId)} icon={<GridAction label={'Eliminar'} Icon={Delete} />} />
          </>
      }
    ];

    const BtnBar = (props) => {


      let IndiceDflt = {
        oficial: '',
        turista: '',
        blue: '',
        mep: '',
        cac: '',
        cvs: '',
        fecha: dayjs(Date.now())
      }


      function handleAdd() {
        setEstamosEditando(IndiceDflt);
        openForm();
      }

      return (
        <Fragment>
          <Button className="mb-3" variant="contained" color='primary'  sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }} onClick={handleAdd}>NUEVO<Add /></Button>
          {/* <IconButton className="mb-3" variant="contained" color='primary' onClick={handleAdd}><Add /></IconButton> */}
        </Fragment>
      );
    };
    const autosizeOptions = {
      includeHeaders: true,
      includeOutliers: false,
      outliersFactor:0,
      expand: false,
    };
    return (
      <Fragment>

        
        <NuevoIndiceForm indice={estamosEditando}></NuevoIndiceForm>
        <Box sx={{  width: '100%' }}>
          <DataGridPro
            pagination
            sx={{ height: '75vh', width: '100%' }}
            getRowId={r => r.indiceId}
            initialState={{
              sorting: {
                sortModel: [{ field: 'fecha', sort: 'desc' }],
              },
              innedColumns: { right: ['actions'] }
            }}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[5]}
            experimentalFeatures={{ newEditingApi: true }}
            loading={fetching > 0}
            components={{
              Toolbar: () => {
                return <Fragment>
                  <GridToolbarContainer>
                    <Grid conteiner
                      rowSpacing={0} sx={{
                        display: "inline-flex",
                        justifyContent: "space-between",
                        alignItems: "strech",
                        width: "100%",
                      }}>
                          {currentUser?.permisos?.includes('writeCACs') ? <BtnBar/> : null}
                      <Grid sx={{ width: "100%", marginLeft: '1em' }}>
                        <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                        {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                          : ''}
                      </Grid>
                      <GridToolbarQuickFilter />
                    </Grid>
                  </GridToolbarContainer>
                </Fragment>
              }
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Header></Header>
      <Notification />
      <IndicesTable></IndicesTable>
    </Fragment>
  )
}